<template>
  <div class="d-flex flex-column h-100 pt-3">
    <div
      class="menu-cell text-start ps-3 d-flex"
      @click="clickMenu(0)"
      style="cursor: pointer"
      :class="{ 'select-menu-color': isSelectColor(0) }"
    >
      <div class="menu-icon ml-2 my-auto">
        <svg xmlns="http://www.w3.org/2000/svg">
        <path class="st0" d="M21.3,15.6C21,15,20.5,14.4,19.9,14v-2.5c0-2.1-0.8-4.1-2.3-5.5c-1.4-1.4-3.1-2.1-4.9-2.3V2.5
          c0-0.4-0.1-0.6-0.4-0.9s-0.5-0.4-0.9-0.4c-0.4,0-0.6,0.1-0.9,0.4c-0.2,0.3-0.4,0.5-0.4,0.9c0,0,0,0.5,0,1.1C8.4,3.8,6.6,4.5,5.4,5.8
          c-1.4,1.5-2.3,3.5-2.3,5.6V14c-0.6,0.5-1.1,1-1.4,1.6c-0.4,0.6-0.5,1.4-0.5,2.2c0,0.9,0.4,1.7,0.9,2.3s1.4,1,2.3,1h3.9
          c0.1,0.8,0.4,1.6,1,2.3c0.6,0.6,1.4,1.1,2.3,1.1c0.9,0,1.7-0.4,2.3-1.1c0.5-0.6,0.9-1.4,1-2.3h3.8c0.8,0,1.7-0.4,2.3-1
          s0.9-1.4,0.9-2.3l0,0C21.9,17.1,21.7,16.2,21.3,15.6z M12.4,22.2c-0.2,0.4-0.6,0.4-0.9,0.4s-0.7-0.2-0.9-0.4
          c-0.2-0.2-0.2-0.4-0.4-1.1h2.6C12.8,21.9,12.6,22.1,12.4,22.2z M19.9,18.8c-0.1,0.1-0.3,0.2-0.5,0.2H3.6c-0.2,0-0.4-0.1-0.5-0.2
          s-0.2-0.3-0.2-0.5c0-2,2.1-3.4,2.1-3.4v-3.6c0-1.5,0.6-3,1.7-4.1s2.5-1.7,4.1-1.7h1.4c1.5,0,3,0.6,4.1,1.7S18,9.8,18,11.3v3.6
          c0,0,2.2,1.3,2.2,3.3C20.2,18.4,20.1,18.5,19.9,18.8z"/>
        </svg>
      </div>
      <div class="ms-3 my-auto">お知らせ</div>
    </div>

    <div
      class="menu-cell-3 text-start ps-3 d-flex"
      @click="clickMenu(1)"
      style="cursor: pointer"
      :class="{ 'select-menu-3-color': isSelectColor(1) }"
    >
      <div class="menu-icon ml-2 my-auto">
        <svg xmlns="http://www.w3.org/2000/svg">
        <path class="st0" d="M8.7,9l0.4,2.2c0.2,1.2,1.1,2.1,2.4,2.3l2.3,0.4c0.1,0,0.3,0,0.4,0h0c0.8,0,1.6-0.3,2.1-0.9l5.8-5.6
          c0.6-0.5,0.9-1.2,0.9-2c0-0.8-0.3-1.5-0.8-2l-2.7-2.6c-1.1-1.1-3-1.1-4.1,0.1L9.6,6.5C8.9,7.1,8.5,8.1,8.7,9z M17.5,1.9L17.5,1.9
          L17.5,1.9c0.2,0,0.4,0.1,0.6,0.2l2.7,2.6C20.9,4.9,21,5.1,21,5.3c0,0.3-0.1,0.5-0.3,0.7l-0.6,0.6l-3.9-3.8l0.6-0.6
          C17,2,17.2,1.9,17.5,1.9z M11,7.8l3.8-3.7L18.7,8l-3.8,3.7c-0.2,0.2-0.6,0.4-0.9,0.3l-2.3-0.4c-0.4-0.1-0.6-0.3-0.7-0.7l-0.4-2.2
          C10.6,8.4,10.7,8,11,7.8z"/>
        <path class="st0" d="M21.9,10.8c-0.5,0-1,0.4-1,1v6.9c0,1.3-1.1,2.4-2.5,2.4h-14C3.1,21,2,19.9,2,18.6V5c0-1.3,1.1-2.4,2.5-2.4h6.4
          c0.5,0,1-0.4,1-1s-0.4-1-1-1H4.4C2,0.7,0,2.6,0,5v13.6C0,21,2,23,4.4,23h14c2.4,0,4.4-1.9,4.4-4.3v-6.9
          C22.9,11.2,22.4,10.8,21.9,10.8z"/>
        </svg>
      </div>
      <div class="ms-3 my-auto">注文</div>
    </div>

    <div
      class="menu-cell-3 text-start ps-3 d-flex"
      @click="clickMenu(6)"
      style="cursor: pointer"
      :class="{ 'select-menu-3-color': isSelectColor(6) }"
    >
      <div class="menu-icon ml-2 my-auto">
        <svg xmlns="http://www.w3.org/2000/svg">
          <path class="st0" d="M8.1,10.1l0.4,2.2c0.2,1.2,1.1,2.1,2.3,2.3L13,15c0.1,0,0.3,0,0.4,0l0,0
            c0.8,0,1.6-0.3,2-0.9l5.7-5.6C21.7,8,22,7.3,22,6.4s-0.3-1.5-0.8-2l-2.6-2.6c-1.1-1.1-2.9-1.1-4,0.1L8.9,7.6
            C8.2,8.2,7.9,9.2,8.1,10.1z M16.6,2.9L16.6,2.9L16.6,2.9c0.2,0,0.4,0.1,0.6,0.2l2.6,2.6C20,5.9,20,6.1,20,6.3c0,0.3-0.1,0.5-0.3,0.7
            l-0.6,0.6l-3.8-3.8L16,3.2C16.1,3,16.3,2.9,16.6,2.9z M10.3,8.9L14,5.1L17.8,9l-3.7,3.7c-0.2,0.2-0.6,0.4-0.9,0.3L11,12.7
            c-0.4-0.1-0.6-0.3-0.7-0.7L9.9,9.8C9.9,9.5,10,9.1,10.3,8.9z"/>
          <path class="st0" d="M21.5,11c-0.5,0-1,0.4-1,1v5.8c0,1.3-1.1,2.4-2.4,2.4H4.6C3.4,20,2.3,19,2.3,17.7V5.3C2.3,4,3.4,3,4.7,3h6.2
            c0.5,0,1-0.4,1-1s-0.4-1-1-1H4.6C2.3,1.1,0.4,3,0.4,5.3v12.4C0.4,20,2.3,22,4.6,22h13.5c2.3,0,4.2-1.9,4.2-4.2V12
            C22.5,11.4,22,11,21.5,11z"/>
          <g>
            <path class="st0" d="M3.6,15.1c0-1,0.8-1.9,2.4-1.9c1.6,0,2.2,0.9,2.2,1.3c0,0.4-0.4,0.8-0.8,0.8c-0.2,0-0.4-0.1-0.6-0.3
              c-0.2-0.3-0.7-0.4-0.9-0.4c-0.5,0-0.8,0.1-0.8,0.4c0,0.1,0.1,0.2,0.1,0.2c0.4,0.1,0.8,0.2,1.5,0.3c1.1,0.3,1.6,0.8,1.6,1.9
              c0,1.1-0.9,1.9-2.5,1.9c-1.9,0-2.4-1.2-2.4-1.6c0-0.4,0.4-0.8,0.8-0.8c0.2,0,0.4,0.1,0.5,0.4c0.2,0.4,0.5,0.6,1.1,0.6
              s0.9-0.2,0.9-0.5c0-0.2-0.2-0.4-0.4-0.5c-0.7-0.2-1.3-0.2-2-0.4C3.8,16.3,3.6,15.7,3.6,15.1z"/>
          </g>
        </svg>
      </div>
      <div class="ms-3 my-auto">サンプル注文</div>
    </div>

    <div
      class="menu-cell text-start ps-3 d-flex"
      @click="clickMenu(2)"
      style="cursor: pointer"
      :class="{ 'select-menu-color': isSelectColor(2) }"
    >
      <div class="menu-icon ml-2 my-auto">
        <svg xmlns="http://www.w3.org/2000/svg">
        <g>
          <path class="st0" d="M22.1,7.4c0.6-0.5,0.9-1.2,0.9-2c0-0.8-0.3-1.5-0.8-2l-2.7-2.6c-1.1-1.1-3-1-4.1,0.1L9.6,6.5
            C8.9,7.1,8.6,8,8.8,9l0.4,2.2c0.2,1.2,1.1,2.1,2.3,2.3l2.3,0.3c0.1,0,0.3,0,0.4,0l0,0h0c0.8,0,1.5-0.3,2.1-0.9L22.1,7.4z M17.5,1.9
            L17.5,1.9L17.5,1.9c0.2,0,0.4,0.1,0.6,0.2l2.7,2.6C20.9,4.9,21,5.1,21,5.3c0,0.3-0.1,0.5-0.3,0.7l-0.6,0.6
            c-0.8-0.7-3.3-3.2-3.9-3.8l0.6-0.6C17,2,17.2,1.9,17.5,1.9z M14.1,11.9l-2.3-0.4c-0.4-0.1-0.6-0.3-0.7-0.7l-0.4-2.2
            c0-0.3,0.1-0.6,0.3-0.9l3.8-3.6L18.7,8l-3.8,3.6C14.7,11.8,14.4,12,14.1,11.9z"/>
          <rect y="8.2" class="st0" width="2.5" height="2.4"/>
          <rect y="15.4" class="st0" width="2.5" height="2.4"/>
          <path class="st0" d="M2.5,7V5.1c0-0.1,0-0.2,0-0.3L0.1,4.4C0,4.7,0,4.9,0,5.1V7L2.5,7L2.5,7z"/>
          <rect y="11.8" class="st0" width="2.5" height="2.4"/>
          <rect x="8.4" y="0.7" class="st0" width="2.5" height="2.4"/>
          <rect x="4.7" y="0.7" class="st0" width="2.5" height="2.4"/>
          <path class="st0" d="M2.7,4.1L2.7,4.1L2.7,4.1C2.7,4.1,2.7,4.1,2.7,4.1L2.7,4.1z"/>
          <polygon class="st0" points="1.6,21.9 1.6,21.9 1.6,21.9 1.6,21.9 	"/>
          <path class="st0" d="M3.9,3.2L3.1,0.9c-1.1,0.3-2,1.1-2.5,2l2.1,1.2C3,3.6,3.4,3.3,3.9,3.2z"/>
          <rect x="20.5" y="10.7" class="st0" width="2.5" height="2.4"/>
          <rect x="20.5" y="14.3" class="st0" width="2.5" height="2.4"/>
          <path class="st0" d="M20.5,18.5c0,0.4-0.1,0.7-0.3,1l2.1,1.2h0c0.4-0.7,0.6-1.5,0.6-2.3v-0.7h-2.5V18.5z"/>
          <path class="st0" d="M18.4,20.6h-0.2V23h0.2v0c1.1,0,2.1-0.3,2.9-1l-1.6-1.8C19.3,20.4,18.9,20.6,18.4,20.6z"/>
          <rect x="14.5" y="20.6" class="st0" width="2.5" height="2.4"/>
          <path class="st0" d="M2.5,18.8L0,19.1c0.2,1.1,0.7,2.1,1.6,2.8l1.6-1.8C2.8,19.8,2.5,19.3,2.5,18.8z"/>
          <rect x="10.8" y="20.6" class="st0" width="2.5" height="2.4"/>
          <path class="st0" d="M3.9,20.5l-0.8,2.2c0.5,0.2,1,0.3,1.5,0.3h1.3v-2.4H4.6C4.4,20.6,4.1,20.6,3.9,20.5z"/>
          <rect x="7.2" y="20.6" class="st0" width="2.5" height="2.4"/>
        </g>
        </svg>
      </div>
      <div class="ms-3 my-auto">下書き・デザイン履歴</div>
    </div>

    <div
      class="menu-cell text-start ps-3 d-flex"
      @click="clickMenu(3)"
      style="cursor: pointer"
      :class="{ 'select-menu-color': isSelectColor(3) }"
    >
      <div class="menu-icon ml-2 my-auto">
        <svg xmlns="http://www.w3.org/2000/svg">
        <path class="st0" d="M11.5,0C5.1,0,0,5.2,0,11.5S5.1,23,11.5,23C17.8,23,23,17.8,23,11.5S17.8,0,11.5,0z M11.5,20.7
          c-5.1,0-9.2-4.1-9.2-9.2s4.1-9.2,9.2-9.2s9.2,4.1,9.2,9.2S16.6,20.7,11.5,20.7z"/>
        <polygon class="st0" points="12.1,5.8 10.3,5.8 10.3,12.7 16.4,16.3 17.2,14.9 12.1,11.8 	"/>
        </svg>
      </div>
      <div class="ms-3 my-auto">注文履歴</div>
    </div>

    <div
      class="menu-cell text-start ps-3 d-flex"
      @click="clickMenu(4)"
      style="cursor: pointer"
      :class="{ 'select-menu-color': isSelectColor(4) }"
    >
      <div class="menu-icon ml-2 my-auto">
        <svg xmlns="http://www.w3.org/2000/svg">
        <path class="st0" d="M9.5,12.6c0,0.2,0,0.4-0.1,0.6s-0.2,0.3-0.3,0.5c-0.1,0.1-0.3,0.2-0.5,0.3S8.2,14.1,8,14.1
          c-0.4,0-0.8-0.1-1-0.4s-0.4-0.6-0.4-1s0.2-0.8,0.4-1s0.6-0.4,1-0.4c0.2,0,0.4,0,0.6,0.1s0.3,0.2,0.5,0.3c0.1,0.1,0.2,0.3,0.3,0.5
          C9.4,12.3,9.5,12.5,9.5,12.6z M14.9,11.2c-0.4,0-0.8,0.1-1,0.4c-0.3,0.3-0.4,0.6-0.4,1s0.1,0.8,0.4,1s0.6,0.4,1,0.4s0.8-0.1,1-0.4
          s0.4-0.6,0.4-1s-0.1-0.8-0.4-1S15.3,11.2,14.9,11.2z M23,11.5c0,3.1-1.2,6-3.4,8.1c-2.2,2.2-5.1,3.4-8.1,3.4c-1.5,0-3-0.3-4.4-0.9
          c-1.4-0.6-2.7-1.4-3.7-2.5C1.2,17.5,0,14.6,0,11.5s1.2-6,3.4-8.1C5.5,1.2,8.4,0,11.5,0c1.5,0,3,0.3,4.4,0.9c1.4,0.6,2.7,1.4,3.7,2.5
          c1.1,1.1,1.9,2.3,2.5,3.7C22.7,8.5,23,10,23,11.5z M10,2.4c1.6,2.7,4.5,4.5,7.9,4.5c0.5,0,1-0.1,1.5-0.1c-1.6-2.7-4.5-4.5-7.9-4.5
          C11,2.3,10.4,2.4,10,2.4z M2.8,8.6c2-1.1,3.5-2.9,4.2-5.1C5,4.6,3.5,6.4,2.8,8.6z M20.7,11.5c0-0.9-0.1-1.8-0.4-2.6
          c-0.8,0.2-1.6,0.3-2.5,0.3c-1.7,0-3.4-0.4-4.9-1.1S10,6.3,8.9,5C8.3,6.4,7.4,7.7,6.3,8.8s-2.5,1.9-4,2.5v0.2c0,5.1,4.1,9.2,9.2,9.2
          S20.7,16.6,20.7,11.5L20.7,11.5z"/>
        </svg>
      </div>
      <div class="ms-3 my-auto">お客様情報・配送先</div>
    </div>

    <div
      class="menu-cell-3 text-start ps-3 d-flex"
      @click="clickMenu(5)"
      style="cursor: pointer"
      :class="{ 'select-menu-3-color': isSelectColor(5) }"
    >
      <div class="menu-icon ml-2 my-auto">
        <svg xmlns="http://www.w3.org/2000/svg">
        <path class="st0" d="M22,10c-1.7-2.5-5.1-3.3-7.8-1.8c-0.4-1.2-1.3-2.1-2.3-2.8c-0.1-1.5-0.8-2.9-1.9-3.9C8.8,0.4,7.2-0.1,5.7,0
          C2.4,0.2-0.1,2.9,0,6.1c0.1,1.5,0.8,3,2,4c0.3,0.2,0.5,0.4,0.8,0.6c0,0.4,0.1,0.8,0.2,1.2l2.2,7c0.5,1.7,1.9,3.1,3.7,3.7
          c0.6,0.2,1.3,0.3,2,0.3l0,0c1.2,0,2.3-0.3,3.3-1l0.8-0.5c0.5-0.3,0.6-1,0.3-1.4c-0.3-0.5-1-0.6-1.5-0.3L13,20.3
          c-1,0.7-2.2,0.8-3.4,0.4c-1.1-0.4-2-1.3-2.3-2.4l-2.2-6.9c0.3,0,0.6,0.1,0.9,0.1l0,0c0.1,0,0.2,0,0.3,0c0.8,0,1.7-0.3,2.5-0.7
          c0.5-0.3,0.7-0.9,0.5-1.4C8.9,9,8.2,8.8,7.7,9.1C7.2,9.3,6.7,9.5,6.1,9.5c-0.4,0-0.8,0-1.2-0.1C5,9.1,5.1,8.8,5.3,8.5
          C5.8,7.6,6.6,7,7.5,6.7c1-0.3,2-0.2,2.9,0.3c0.9,0.5,1.5,1.2,1.8,2.2l0.3,1c0.1,0.3,0.3,0.6,0.7,0.7c0.3,0.1,0.7,0.1,1-0.1l0.8-0.5
          c1.7-1.1,4.1-0.7,5.3,1c1.2,1.7,0.7,4-1,5.1l-1.6,1c-0.5,0.3-0.6,1-0.3,1.4c0.3,0.5,1,0.6,1.5,0.3l1.6-1.1
          C23.1,16.3,23.8,12.7,22,10z M6.9,4.7C5.4,5.2,4.2,6.2,3.4,7.5C3.3,7.8,3.2,8,3.1,8.3C2.5,7.6,2.2,6.8,2.1,6C2,3.9,3.6,2.2,5.8,2.1
          c1-0.1,2,0.3,2.8,0.9c0.5,0.4,0.8,1,1,1.5C8.7,4.4,7.8,4.5,6.9,4.7z"/>
        </svg>
      </div>
      <div class="ms-3 my-auto">オプションアイテム</div>
    </div>

    <div v-if="isDebug"
      class="menu-cell text-start ps-3 d-flex"
      @click="clickMenu(7)"
      style="cursor: pointer"
      :class="{ 'select-menu-color': isSelectColor(7) }"
    >
      <div class="menu-icon ml-2 my-auto">
        <svg xmlns="http://www.w3.org/2000/svg" >
        <path d="M9.5264 8.07456L2.5868 8.88103C2.33651 8.91279 2.1152 9.08817 2.03221 9.35469C1.94922 9.62121 2.03221 9.89878 2.21663 10.0742C4.27954 12.0475 7.37918 15.0027 7.37918 15.0027C7.37654 15.0027 6.5282 19.3016 5.96439 22.1698C5.93751 22.2996 5.94723 22.4348 5.99235 22.5589C6.03747 22.6831 6.11605 22.7908 6.21852 22.8689C6.32099 22.9471 6.44293 22.9923 6.56948 22.9991C6.69603 23.0059 6.82174 22.974 6.93129 22.9072C9.36042 21.46 12.9988 19.2836 12.9988 19.2836L19.0637 22.9086C19.285 23.0356 19.5617 23.0329 19.7764 22.8685C19.8786 22.7904 19.9571 22.6831 20.0027 22.5595C20.0482 22.4358 20.0588 22.301 20.0333 22.1712L18.6224 15.0027L23.785 10.0783C23.8785 9.98915 23.9455 9.87363 23.9779 9.74558C24.0104 9.61754 24.007 9.4824 23.9681 9.35634C23.9291 9.23029 23.8564 9.11867 23.7585 9.03486C23.6606 8.95105 23.5417 8.8986 23.4161 8.88379C20.6392 8.55789 16.4752 8.07456 16.4752 8.07456L13.5995 1.40463C13.5474 1.28401 13.4632 1.18169 13.357 1.10993C13.2508 1.03817 13.1271 1 13.0008 1C12.8745 1 12.7508 1.03817 12.6446 1.10993C12.5385 1.18169 12.4542 1.28401 12.4021 1.40463L9.5264 8.07456Z"/>
        </svg>
      </div>
      <div class="ms-3 my-auto">ACRY TICKET管理</div>
    </div>

    <div class="text-start flex-grow-1 mt-auto d-flex flex-column-reverse">
      <div class="py-3 text-start flex-grow-1 mt-auto d-flex flex-column">
        <div class="flex-grow-1"></div>
        <div class="px-3 my-2" style="cursor: pointer;" @click="clickContact">
          お問い合わせ
        </div>
        <div class="px-3 my-2" style="cursor: pointer;" @click="clickGuid">
          ご利用ガイド
        </div>
        <div class="px-3 my-2" style="cursor: pointer;" @click="clickLogout">
          ログアウト
        </div>
        <div class="py-2 px-2 mt-3 text-start company-name d-flex justify-content-between"
        v-if="this.userInfo != null && this.destinationList[this.selectedDestination].name01">
          <div style="font-size:14px;margin-top: 2px;">
            {{this.getCompanyName}}
          </div>
          <img v-if="this.$store.state.isSignature" src="@/assets/acrypro/contract_1.svg" style="width:72px;" />
          <img v-if="!this.$store.state.isSignature" src="@/assets/acrypro/contract_2.svg" style="width:72px;cursor:pointer;" @click="resendSignature" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import { User } from "@/js/User.js";
import { CenterViewState, RightViewState } from "@/js/Const.js";
import firebase from "firebase/app";
import { Analytics } from "@/js/Analytics.js";
import config from 'config'

export default {
  name: "LeftMenu_Ap",
  props: {},
  data: function () {
    return {
      destinationList: [],
      userInfo:null,
      selectedDestination: 0,
      selectMenuId: 0,
      email: "",
      fbUserData:null,
    };
  },
  computed: {
    isDebug(){
      return config.isDebug;
    },
    getCompanyName(){
      if( this.fbUserData && "isIndividual" in this.fbUserData && this.fbUserData.isIndividual ){
        // 個人
        return this.destinationList[this.selectedDestination].name01 + ' ' + this.destinationList[this.selectedDestination].name02;
      }else{
        // 法人
        if( this.destinationList[this.selectedDestination].company_name ){
          if( this.destinationList[this.selectedDestination].company_name.length <= 11 ){
            return this.destinationList[this.selectedDestination].company_name;
          }else{
            return this.destinationList[this.selectedDestination].company_name.slice( 0, 10 ) + '...';
          }
        }else{
          return '';
        }
      }
    }
  },
  created: async function () {
    this.selectMenuId = 0;
    await User.get
    this.fbUserData = await User.getFBAcryProUserData().catch(() => {
      console.log("エラー");
    });
    this.destinationList = await User.getDestinationList().catch((e) => {
      this.$common.log(e);
      this.$store.commit("showMessage", "エラーが発生しました");
    });
    this.userInfo = await User.getInfo();
    console.log("----------------------------------------------")
    console.log(this.userInfo)
    this.email = (await User.getInfo()).email;
  },
  components: {},
  methods: {
    isSelectColor(menuId) {
      return this.selectMenuId == menuId;
    },

    clickMenu(menuId) {
      this.menuId = menuId;
      if( [CenterViewState.Preview, CenterViewState.Edit, CenterViewState.BehalfCreate,
        CenterViewState.EventCreate, CenterViewState.EventEdit, CenterViewState.EventDesignUpload,
        CenterViewState.FirstTimeFreeSurvey
      ].includes(this.$store.state.centerViewState)){
        // 編集中の場合は警告
        this.$store.commit("setYesNoDialogCallback", this.changeViewState);
        this.$store.commit("showYesNoDialog", "編集中です。\nこのページから移動しますか？");
        return;
      }

      if( [RightViewState.FirstTimeFreeUpload
      ].includes(this.$store.state.rightViewState)){
        // 編集中の場合は警告
        this.$store.commit("setYesNoDialogCallback", this.changeViewState);
        this.$store.commit("showYesNoDialog", "編集中です。\nこのページから移動しますか？");
        return;
      }

      this.changeViewState();
    },
    changeViewState(){
      this.selectMenuId = this.menuId;

      switch (this.menuId) {
        case 0:
          this.$store.commit("setCenterViewState", CenterViewState.Info);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
        case 1:
          this.$store.commit("setCenterViewState", CenterViewState.Upload);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
        case 2:
          this.$store.commit("setCenterViewState", CenterViewState.Draft);
          this.$store.commit("setRightViewState", RightViewState.Draft);
          break;
        case 3:
          this.$store.commit("setCenterViewState", CenterViewState.OrderHistory);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
        case 4:
          this.$store.commit("setCenterViewState", CenterViewState.Shipping);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
        case 5:
          this.$store.commit("setCenterViewState", CenterViewState.Option);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
        case 6:
          this.$store.commit("setCenterViewState", CenterViewState.SampleUpload);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
        case 7:
          this.$store.commit("setCenterViewState", CenterViewState.EventManagement);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
      }
    },
    resendSignature(){
      this.$store.commit("showResendContractDialog");

    // let envelopeXID = null;
    //   await User.getFBAcryProUserData().then((data) => {
    //     if (data.envelopeXID) {
    //       envelopeXID = data.envelopeXID;
    //     }
    //   });
    //   if( envelopeXID ){
    //     // 契約書を再送信
    //     await User.resendRequest(envelopeXID).then(()=>{
    //       this.$store.commit("showMessage", "契約書を再送信しました");
    //     })
    //     .catch(()=>{
    //       this.$store.commit("showMessage", "エラーが発生しました")
    //     });
    //   }
    },
    clickContact(){
      router.push("/contact");
    },
    clickGuid(){
      window.open('https://www.acry.jp/acryproguide', '_blank')
    },
    clickLogout(){
      this.$store.commit("setYesNoDialogCallback", this.logoutProcess);
      this.$store.commit("showYesNoDialog", "ログアウトしますか？");
    },
    logoutProcess(){
      this.$store.commit("logout");
      Analytics.setUserId(null);
      firebase
        .auth()
        .signOut()
        .then(function () {
          // this.$store.commit("resetData");
          router.push("/");
        })
        .catch((error) => {
          this.$common.log(error.message);
          // this.$store.commit("resetData");
          router.push("/");
        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.menu-cell{
  fill: $primary-main-color;
  font-size: 1em;
  font-weight: bold;
  height: 44px;
  color: $text-main-color;
}
.menu-cell:hover {
  fill: $text-white-color;
  color: $text-white-color;
  background-color: $primary-main-color;
}
.select-menu-color {
  fill: $text-white-color;
  color: $text-white-color;
  background-color: $primary-main-color;
}

.menu-cell-stroke{
  stroke: $primary-main-color;
  fill: $background-purplegray-color;
  font-size: 1em;
  font-weight: bold;
  height: 44px;
  color: $text-main-color;
}
.menu-cell-stroke:hover {
  fill: $primary-main-color;
  stroke: $text-white-color;
  color: $text-white-color;
  background-color: $primary-main-color;
}
.select-menu-stroke-color {
  fill: $primary-main-color;
  stroke: $text-white-color;
  color: $text-white-color;
  background-color: $primary-main-color;
}

.menu-cell-order{
  stroke: $primary-main-color;
  fill: $primary-main-color;
  font-size: 1em;
  font-weight: bold;
  height: 44px;
  color: $text-main-color;
}
.menu-cell-order:hover {
  fill: $text-white-color;
  stroke: $text-white-color;
  color: $text-white-color;
  background-color: $primary-main-color;
}

.select-menu-icon-order{
  fill: $text-white-color;
  stroke: $text-white-color;
  color: $text-white-color;
  background-color: $primary-main-color;
}


.menu-cell-3{
  fill: $primary-main-color;
  font-size: 1em;
  font-weight: bold;
  height: 44px;
  color: $text-main-color;
}
.menu-cell-3:hover {
  fill: $text-white-color;
  color: $text-white-color;
  background-color: $primary-main-color;
}
.select-menu-3-color {
  fill: $text-white-color;
  color: $text-white-color;
  background-color: $primary-main-color;
}


.menu-icon{
  width: 20px;
  height: 20px;
}

.element {
  position: relative;
  bottom: 0;
  width: 100%;
}

.company-name{
  border: 1px solid $primary-main-color;
  background: #ffffff;
  color: $primary-main-color;
  font-weight: bold;
}
</style>
